import React from 'react';
import type { CategoryCount } from '../api/categoryCounts';
import { useLanguage } from '../context/LanguageContext';

export default function CategoryCountBadge({ countKey, count }: { countKey: string; count?: CategoryCount }) {
  const { t, language } = useLanguage();
  const ready = count?.count_status === 'ready' && count.total != null && !count.total_capped;
  const unavailable = count?.count_status === 'error' || !!count?.total_capped;
  const timestamp = count?.counted_at ? new Date(count.counted_at) : null;
  const title = `${t('lots.picker.allTime')}${timestamp && !isNaN(timestamp.getTime()) ? ` · ${t('lots.picker.countedAt')}: ${timestamp.toLocaleString(language === 'kk' ? 'kk-KZ' : 'ru-RU')}` : ''}`;
  return (
    <span data-category-count-key={countKey} title={title} className="text-xs text-gray-400 shrink-0" aria-label={ready ? `${count!.total!.toLocaleString('ru-RU')} ${t('lots.picker.lotsCount')}. ${title}` : t(unavailable ? 'lots.count.unavailable' : 'lots.count.pending')}>
      {ready ? `${count!.total!.toLocaleString('ru-RU')} ${t('lots.picker.lotsCount')}` : unavailable ? '—' : '…'}
    </span>
  );
}
